/** @format */

import axios from 'axios'

import { notification } from 'antd'

import { ENV_COUNTRY, ENV_FUNCTION_FRONT_COMMON } from '../../../../../../../hooks/enviroment'

export async function serviceSearchProduct(item) {
	return axios({
		method: 'GET',
		url: `${ENV_FUNCTION_FRONT_COMMON}/search/${ENV_COUNTRY}`,
		params: {
			q: item.value,
			root_pharmacy: 'pharol',
		},
	})
		.then((response) => {
			if (response.data.statusCode === 200) {
				return response.data.data
			} else {
				notification.error({
					message: response.data.error,
					description: response.data.message,
				})
				return response.data
			}
		})
		.catch((error) => {
			notification.error({
				message: 'Error de servicio',
				description: `${ENV_FUNCTION_FRONT_COMMON}/search/${ENV_COUNTRY}`,
			})
		})
}
